import React from "react";
import S from "../../../styles/components";
import SummaryView from "./SummaryView";

// Todo: Styling is repeating for each component.
//  Can we live with this or should global styles
//  be created? How does style-components handle
//  relationships between components?

/* eslint react/prefer-stateless-function:0 */
class Index extends React.PureComponent {
  render() {
    const { summaryData } = this.props;
    return (
      <S.Fields>
        <SummaryView summaryData={summaryData} />
      </S.Fields>
    );
  }
}

export default Index;
